const loadBambuserShow = (showId, node) => {
  if (!window.initBambuserLiveShopping){
    window.initBambuserLiveShopping = function(item) { 
      window.initBambuserLiveShopping.queue.push(item) 
    }; 
    window.initBambuserLiveShopping.queue = [];
    const scriptNode = document.createElement('script');
    scriptNode['src'] = 'https://lcx-embed-eu.bambuser.com/default/embed.js';
    document.body.appendChild(scriptNode);
  }

  window.initBambuserLiveShopping({
    showId,
    node,
    type: 'overlay',
  });
}

const viewMoreButton = () => {
  const viewMore = document.querySelector('[data-bambuser-view-more]')
  if (viewMore) {
    viewMore.addEventListener('click', (e) => {
      e.preventDefault();
      const bambuserHiddenShows = document.querySelectorAll('[data-bambuser-show].hide');
      if (bambuserHiddenShows.length > 0) {
        [...bambuserHiddenShows].slice(0,3).forEach(bambuserShowBtn => {
          bambuserShowBtn.classList.remove('hide')
        })
      }        
      if (bambuserHiddenShows.length <= 2) {
        viewMore.classList.add('hide')
      }
    })
  }
}

const bambuserify = () => {

  const bambuserShows = document.querySelectorAll('[data-bambuser-show]');
  if (!bambuserShows) { return }
  viewMoreButton()
  bambuserShows.forEach(bambuserShowBtn => {
    // bambuserShowBtn.addEventListener('click', () => {
    const bambuserId = bambuserShowBtn.dataset.bambuserShow
    if (bambuserId) {
      loadBambuserShow(bambuserId, bambuserShowBtn)
    }
    // })
  })
  
}
export default bambuserify;